import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const SuccessIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 64 64" sx={{ height: '64px', width: '64px', ...sx }} {...props}>
      <g clipPath="url(#clip0_1337_6213)">
        <path
          d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
          fill="#24B07E"
        />
        <path
          d="M26.5 47.3187L41.6533 62C54.2035 58.7575 63.5 47.679 63.5 34.4388C63.5 34.1686 63.5 33.8984 63.5 33.6282L51.6005 23L26.5 47.3187Z"
          fill="#21A173"
        />
        <path
          d="M32.6932 38.1697C33.9068 39.3833 33.9068 41.4637 32.6932 42.6773L30.1795 45.1911C28.9659 46.4047 26.8856 46.4047 25.6721 45.1911L14.6636 34.0956C13.45 32.882 13.45 30.8016 14.6636 29.5881L17.1773 27.0742C18.3909 25.8607 20.4712 25.8607 21.6847 27.0742L32.6932 38.1697Z"
          fill="white"
        />
        <path
          d="M42.3169 19.0117C43.5304 17.7982 45.6108 17.7982 46.8243 19.0117L49.338 21.5256C50.5516 22.7391 50.5516 24.8195 49.338 26.0331L30.2682 45.0168C29.0547 46.2304 26.9743 46.2304 25.7608 45.0168L23.2471 42.503C22.0335 41.2894 22.0335 39.209 23.2471 37.9954L42.3169 19.0117Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1337_6213">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default SuccessIcon;
